"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanTooltips = void 0;
var cleanTooltips = function () {
    var ps = Array.from(document.querySelectorAll('.tooltip'));
    ps.forEach(function (e) { return e.remove(); });
};
exports.cleanTooltips = cleanTooltips;
//# sourceMappingURL=index.js.map